export enum MediaFieldType {
  Documents = 'documents',
  Photos = 'photos',
  All = 'all'
}
